import React from 'react';
import { Link } from 'react-router-dom';
import { useT } from '../i18n';
import useSeo from '../hooks/useSeo';
import './InfoPages.css';

// ── 404 ──────────────────────────────────────────────────────────────────────
// The catch-all route used to be `<Navigate to="/" replace />`, which sent every
// unknown URL to the homepage. Two things were wrong with that.
//
// A SOFT 404 IS A FAULT, not a tidy redirect. Google's own guidance names it
// explicitly: a missing page that answers with a 200 and some other page's
// content is worse than one that says it is missing, because the crawler cannot
// tell a typo from a real page and keeps both in the index. Every mistyped or
// stale link on the site was quietly becoming another copy of the homepage.
//
// AND IT BROKE THE BUILD. react-snap prerenders /404.html, saw a route that
// redirects, and exited non-zero — which fails `npm run build`, because
// react-snap runs as `postbuild`. The deploy would have failed on Render with
// every page prerendered perfectly well. The title below is what it checks for.
//
// Translated inline rather than through i18n/index.js: three strings used on one
// screen that nobody should ever reach, against a 4,000-line dictionary that
// every visitor downloads.
const COPY = {
  en: { t: 'Page not found',      b: 'The page you are looking for does not exist or has moved.', h: 'Go to the homepage' },
  ru: { t: 'Страница не найдена', b: 'Страница не существует или была перемещена.',               h: 'На главную' },
  hy: { t: 'Էջը չի գտնվել',       b: 'Այս էջը գոյություն չունի կամ տեղափոխվել է։',                h: 'Դեպի գլխավոր' },
};

export default function NotFound() {
  const { lang } = useT();
  const c = COPY[lang] || COPY.en;

  // "404" IS IN THE TITLE ON PURPOSE — react-snap checks for exactly that string
  // and warns without it. `noindex` because a not-found page has nothing to
  // offer a search result, while `follow` keeps the crawler walking the links.
  useSeo({
    title: `404 — ${c.t} | Tunify`,
    description: c.b,
    noindex: true,
  });

  return (
    <div className="dash-root">
      <main className="dash-main ifp-main">
        <h1 className="ifp-title">404</h1>
        <p className="ifp-lead">{c.t}</p>
        <p>{c.b}</p>
        <p><Link to="/">{c.h}</Link></p>
      </main>
    </div>
  );
}
